export default {
    unknownUser: 'Unknown User',
    today: 'Today',
    previous: 'Previous',
    next: 'Next',
    month: 'Month',
    week: 'Week',
    day: 'Day',
    agenda: 'Agenda',
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    noEventsInRange: 'No events in this range',
    noReservations: 'No reservations to display',
    showMore: '+ {{[count]}} more',
    work_week: 'Work Week',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    from: 'From',
    to: 'To',
    reservedBy: 'Reserved by {{user}}',
    borrowedBy: 'Borrowed by {{user}}',
    loadingReservations: 'Loading reservations...',
    errorLoadingReservations: 'Error loading reservations',
    selectTimeSlot: 'Select a time slot to create a reservation',
    viewReservationDetails: 'Click to view reservation details',
    viewBorrowingDetails: 'Click to view borrowing details',
    timezone: 'Times displayed in Paris time (CEST/CET)',
};
